// BaseDialog.js

export default {
  baseDialog: {
    titles: {
      filters: 'Filtrar'
    }
  }
}
